import { Helmet } from 'react-helmet-async';
import { useCurrentWorkspace } from 'src/context/reducers/app-settings';
import NonBrandedOverviewSection from 'src/sections/overview/dashboards/views/non-branded/views/search-terms';

export default function NonBrandedSearchPerformance() {
  const workspace = useCurrentWorkspace();

  return (
    <>
      <Helmet>
        <title>Search Performance</title>
      </Helmet>

      {/* Keyed by workspace: a switch remounts the section so its landing defaults (countries) are re-applied. */}
      <NonBrandedOverviewSection key={workspace?.id} />
    </>
  );
}
